import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const ErrorSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.2096 1.66675C10.4749 1.66675 10.7293 1.77218 10.9169 1.95983L14.0406 5.08522C14.228 5.27274 14.3333 5.52701 14.3333 5.79214V10.2105C14.3333
       10.4757 14.2279 10.7301 14.0403 10.9177L10.9168 14.0406C10.7293 14.2281 10.475 14.3334 10.2098 14.3334H5.7914C5.52625 14.3334 5.27195 14.2281
        5.08442 14.0406L1.95965 10.917C1.77203 10.7294 1.66663 10.475 1.66663 10.2098V5.79163C1.66663 5.52641 1.77198 5.27206 1.95952 5.08452L5.0844
         1.95964C5.27194 1.7721 5.52629 1.66675 5.79151 1.66675H10.2096ZM10.3642 3.29297C10.1766 3.10544 9.9223 3.00008 9.65708 3.00008H6.34364C6.07834
          3.00008 5.82392 3.1055 5.63637 3.29314L3.29336 5.63722C3.10592 5.82474 3.00063 6.07902 3.00063 6.34416V9.65793C3.00063 9.92311 3.10595 10.1774
           3.29344 10.365L5.63639 12.7084C5.82393 12.896 6.07832 13.0014 6.34357 13.0014H9.65708C9.92229 13.0014 10.1766 12.8961 10.3642 12.7085L12.7077
            10.365C12.8953 10.1774 13.0006 9.92308 13.0006 9.65787V6.34363C13.0006 6.07841 12.8953 5.82406 12.7077 5.63652L10.3642 3.29297ZM7.33329
             10.6667C7.33329 10.2986 7.63177 10.0001 7.99996 10.0001C8.36815 10.0001 8.66663 10.2986 8.66663 10.6667C8.66663 11.0349 8.36815 11.3334
              7.99996 11.3334C7.63177 11.3334 7.33329 11.0349 7.33329 10.6667ZM7.33329 5.33341C7.33329 4.96522 7.63177 4.66675 7.99996 4.66675C8.36815
               4.66675 8.66663 4.96522 8.66663 5.33341V8.00008C8.66663 8.36827 8.36815 8.66675 7.99996 8.66675C7.63177 8.66675 7.33329 8.36827 7.33329 8.00008V5.33341Z"
      fill="#7A130A"
    />
  </svg>
);
const ErrorIcon = (props: IIconProps) => <Icon component={ErrorSvg} {...props} />;

export default ErrorIcon;
